import { runConversion } from './worker/workerClient';
import { DocxImportError } from './errors';
import { DEFAULT_LIMITS } from './limits';

export { DocxImportError, DOCX_ERRORS } from './errors';

/*
 * Public entry point of the Word importer. Only the worker client is imported
 * here, so the converter itself never lands in the main bundle.
 */

const randomPrefix = () => `w${Math.random().toString(36).slice(2, 8)}-`;

/**
 * Converts a .docx file into CKEditor HTML.
 *
 * @param {File|Blob|ArrayBuffer|Uint8Array} input
 * @param {{signal?: AbortSignal, onProgress?: (phase: string) => void, limits?: object, idPrefix?: string,
 *          createWorker?: Function}} [opts]
 * @returns {Promise<{html: string, assets: {id: string, part: string, mime: string, name: string, bytes: Uint8Array}[],
 *                    warnings: {code: string, count: number, sample?: string}[], stats: object}>}
 *   The HTML references images as `src="docx-asset:<id>"`.
 */
export async function importDocx(input, opts = {}) {
    const limits = { ...DEFAULT_LIMITS, ...(opts.limits || {}) };
    let bytes;
    if (input instanceof ArrayBuffer) bytes = input.slice(0);
    else if (ArrayBuffer.isView(input)) bytes = input.buffer.slice(input.byteOffset, input.byteOffset + input.byteLength);
    else if (input && typeof input.arrayBuffer === 'function') {
        if (input.size > limits.maxInputBytes) throw new DocxImportError('LIMIT_INPUT');
        bytes = await input.arrayBuffer();
    } else {
        throw new DocxImportError('NOT_A_ZIP', 'unsupported input');
    }
    if (bytes.byteLength > limits.maxInputBytes) throw new DocxImportError('LIMIT_INPUT');

    return runConversion(bytes, {
        signal: opts.signal,
        onProgress: opts.onProgress,
        createWorker: opts.createWorker,
        options: { limits: opts.limits, idPrefix: opts.idPrefix || randomPrefix() },
    });
}
